import Header from './Header';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col font-sans text-slate-900 bg-white">
      <ScrollToTop />
      <Header />
      <main className="flex-grow pt-[73px] md:pt-[105px]">
        {children}
      </main>
      <Footer />
    </div>
  );
}
